<template>
  <!-- Modal -->
        <div class="modal fade" ref="vuemodal" id="modalEndereco" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >Cadastrar Endereço</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="enviarEndereco()" autoComplete="off" >
                    <div class="modal-body">

                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Endereço</h3>

                            </div>

                            <div class="card-body" v-if="!carregando">

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Nome:</label>
                                    <div class="col-sm-8">
                                        <input
                                            type="text"
                                            name="nome_end"
                                            v-model="form.nome"
                                            placeholder="Ex: Casa, Trabalho..."
                                            class="form-control form-control-lg"
                                            autoComplete="off"
                                            :class="{ 'is-invalid': form.errors.has('nome') }">
                                        <has-error :form="form" field="nome"></has-error>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Cidade:</label>
                                    <div class="col-sm-8">
                                        <select class="form-control form-control-lg" v-model.number="form.cidade_id" :class="{ 'is-invalid': form.errors.has('cidade_id') }">
                                            <option
                                                v-for="(cid,index) in cidades" :key="index"
                                                :value="index"
                                                :selected="index == form.cidade_id">{{ cid }}</option>
                                            </select>
                                        <has-error :form="form" field="cidade_id"></has-error>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Bairro:</label>
                                    <div class="col-sm-8">
                                        <select class="form-control form-control-lg" v-model.number="form.bairro_id" :class="{ 'is-invalid': form.errors.has('bairro_id') }">
                                            <option
                                                v-for="bairro in bairros.filter(bairro => bairro.cidade_id == form.cidade_id)"
                                                :key="bairro.id"
                                                :value="bairro.id"
                                                :selected="bairro.id == form.bairro_id">{{ bairro.nome }}</option>
                                            </select>
                                        <has-error :form="form" field="bairro_id"></has-error>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Cep:</label>
                                    <div class="col-sm-8">

                                        <the-mask
                                            autoComplete="off"
                                            mask="#####-###"
                                            :masked="true"
                                            type="text"
                                            inputmode="numeric"
                                            name="cep_end"
                                            v-model="form.cep"
                                            class="form-control form-control-lg"
                                            :class="{ 'is-invalid': form.errors.has('cep') }"
                                        >
                                        </the-mask>


                                        <has-error :form="form" field="cep"></has-error>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Endereço:</label>
                                    <div class="col-sm-8">
                                        <input type="text"
                                            autoComplete="off"
                                            name="logradouro_end"
                                            v-model="form.logradouro"
                                            class="form-control form-control-lg"
                                            :class="{ 'is-invalid': form.errors.has('logradouro') }">
                                        <has-error :form="form" field="logradouro"></has-error>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Numero:</label>
                                    <div class="col-sm-8">
                                        <input type="text"
                                            autoComplete="off"
                                            name="numero_end"
                                            v-model="form.numero"
                                            class="form-control form-control-lg"
                                            :class="{ 'is-invalid': form.errors.has('numero') }">
                                        <has-error :form="form" field="numero"></has-error>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Complemento:</label>
                                    <div class="col-sm-8">
                                        <input type="text"
                                            autoComplete="off"
                                            name="complemento_end"
                                            v-model="form.complemento"
                                            class="form-control form-control-lg"
                                            :class="{ 'is-invalid': form.errors.has('complemento') }">
                                        <has-error :form="form" field="complemento"></has-error>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Ponto de Referência:</label>
                                    <div class="col-sm-8">
                                        <input type="text"
                                            autoComplete="off"
                                            name="referencia_end"
                                            v-model="form.referencia"
                                            class="form-control form-control-lg"
                                            :class="{ 'is-invalid': form.errors.has('referencia') }">
                                        <has-error :form="form" field="referencia"></has-error>
                                    </div>
                                </div>

                            </div>


                            <div v-else class="text-center">
                                <div class="spinner-border text-info my-5" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>


                    </div>



                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="submit" class="btn h-btn">Cadastrar</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
</template>

<script>
import api from "../service/api";
import Cookie from "js-cookie";

export default {
    data () {
        return {
            carregando:false,
            cidades:{},
            bairros:[],
            editmode: false,

            form: new Form({
                id:'',
                cidade_id:'',
                bairro_id:'',
                nome:'',
                cep:'',
                logradouro:'',
                numero:'',
                complemento:'',
                referencia:''
            }),
        }
    },

    watch: {
        enderecoAtivo: function (endereco) {
            this.form.fill(endereco);
        },
    },

    methods: {

        carregarEndereco(endereco){

            this.form.fill(endereco);
          },

        async carregarBairros(){
            this.carregando = true;
            await api
            .get('/bairros-all')
            .then(response => (this.bairros = response.data.data));

            this.carregando = false
          },

        async carregarCidades(){
            this.carregando = true;
            await api
            .get('/cidades_lista')
            .then(response => (this.cidades = response.data));

            this.carregando = false
        },


        enviarEndereco(){
            this.carregando = true;

            let formData = new FormData();

            formData.append('nome', this.form.nome);
            formData.append('bairro_id', this.form.bairro_id);
            formData.append('cep', this.form.cep);
            formData.append('logradouro', this.form.logradouro);
            formData.append('numero', this.form.numero);
            formData.append('complemento', this.form.complemento);
            formData.append('referencia', this.form.referencia);


            api.post(
                this.form.id
                ?'/endereco/'+this.form.id+'?_method=PUT'
                :'/endereco'
                ,formData, { headers: {'Content-Type': 'multipart/form-data'} }
            )
            .then((response) => {

                if (response.data.success) {
                    // success
                    // $('#modalEndereco').modal('hide');

                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });

                    const pagina = Cookie.get('proximaPagina');

                    this.$store.dispatch('fetchPerfil').then();

                    switch (pagina) {
                        case 'perfil':
                            this.$router.go();
                            break;

                        case 'finalizarCompra':
                            $('#modalEndereco').modal('hide');
                            setTimeout(function() {
                                $('#modalFinalizarCompra').modal('show')
                            }, 400);

                            break;

                        default:
                            break;
                    }

                    this.carregando = false;

                }else{
                    this.form.errors.errors =  response.data.error;

                    Toast.fire({
                        icon: 'error',
                        title: 'Não foi possivel atualizar!'
                    });

                    this.carregando = false;

                    // this.$Progress.failed();
                }

            })
            .catch(() => {
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });

                this.carregando = false;
            });

        },

        async fecharModal(){
            await this.$store.dispatch('hideAllModals').then();
        }




    },

    computed: {
        enderecoAtivo() {
            return this.$store.state.enderecoAtivo.main;
        },


    },


    mounted() {

        $(this.$refs.vuemodal).on("hidden.bs.modal", this.fecharModal);

        this.carregarBairros();
        this.carregarCidades();
        this.carregarEndereco();
    }

}
</script>

<style scoped>



</style>
